<template>
  <v-app :class="{ 'fixed-min-size': fixedMinSize }">
    <router-view name="header" />
    <router-view name="gnb" />
    <div class="layout h-100" @contextmenu.prevent v-on:click.ctrl="onFn9">
      <router-view />
    </div>
    <snackbar />
    <owl-dialog ref="dialog"></owl-dialog>
    <!--v-overlay absolute :z-index="10000" :value="blocking"-->
    <v-overlay absolute :z-index="10000" :value="blocking && licenseBlocking">
      <!--v-btn color="error">License has expired</v-btn-->
      <v-btn color="error" @click="resetBlocking()">{{ getServerMessage }}</v-btn>
    </v-overlay>
    <v-overlay absolute :z-index="10000" :value="screenBlock" :opacity="100">
      <img src="../../assets/image/loginBgDark.gif" v-on:click="onFn9" width="100%" />
      <!--img src="../../assets/image/changshin.jpg" v-on:click="onFn9" width="100%" /-->
    </v-overlay>
  </v-app>
</template>

<script>
import Dialogable from '@/mixins/dialogable';
import Axiosable from '@/mixins/axiosable';
import Blockable from '@/mixins/blockable';
import Snackbar from '@/components/Snackbar';
// BEGIN::Added.by.KWShin.2025.04.17.
import { mapGetters } from 'vuex';
// END::Added.by.KWShin.2025.04.17.

export default {
  metaInfo: {
    title: 'OWLens',
    titleTemplate: '%s',
  },
  components: {
    Snackbar,
  },
  mixins: [Dialogable, Axiosable, Blockable],
  data() {
    return {
      screenBlock: false,
      // BEGIN::Added.by.KWShin.2025.04.17.
      licenseBlocking: true,
      // END::Added.by.KWShin.2025.04.17.
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2025.04.17.
    ...mapGetters('common/auth', ['getServerMessage']),
    // END::Added.by.KWShin.2025.04.17.
    fixedMinSize() {
      return this.$route.meta.fixedMinSize == undefined ? true : this.$route.meta.fixedMinSize;
    },
  },
  methods: {
    onFn9() {
      this.screenBlock = !this.screenBlock;
    },
    // BEGIN::Added.by.KWShin.2025.04.17.
    // 메시지를 표시하여주는 버튼을 클릭하면 화면 blocking을 해제했다가
    // 30초 뒤에 다시 blocking함.
    // 라이선스에 문제가 있어도 사용은 계속할 수 있게 하되 불편하게 만들 목적임.
    resetBlocking() {
      this.licenseBlocking = !this.licenseBlocking;
      setTimeout(() => {
        this.licenseBlocking = !this.licenseBlocking;
      }, 30000);
    },
    // END::Added.by.KWShin.2025.04.17.
  },
  created() {
    document.documentElement.setAttribute('lang', this.$i18n.locale);
  },
};
</script>

<style lang="scss">
@import '../../style/main';
</style>
